module.exports = __webpack_public_path__ + "static/img/B.d873d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qh/B.png
// module id = Vgkd
// module chunks = 0